import { configureStore } from '@reduxjs/toolkit'
import counterReducer from '../features/counter/counterSlice';
import i18nReducer from "../services/i18n/i18nSlice";
import appInfoReducer from '../services/utils/appInfoSlice';
import authReducer from '../services/auth/authSlice';
import userReducer  from '../features/User/userSlice';
import errorSlice from '../features/Error/errorSlice';
import globalSlice from '../services/global/globalSlice';

export const store = configureStore({
  reducer: {
    global: globalSlice,
    auth: authReducer,
    counter: counterReducer,
    i18n: i18nReducer,
    appInfo: appInfoReducer,
    userInfo: userReducer,
    errorManager: errorSlice
  },
});